/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPerson } from './InternalApiPerson';
import {
    InternalApiPersonFromJSON,
    InternalApiPersonFromJSONTyped,
    InternalApiPersonToJSON,
    InternalApiPersonToJSONTyped,
} from './InternalApiPerson';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';
import type { InternalApiScoreResult } from './InternalApiScoreResult';
import {
    InternalApiScoreResultFromJSON,
    InternalApiScoreResultFromJSONTyped,
    InternalApiScoreResultToJSON,
    InternalApiScoreResultToJSONTyped,
} from './InternalApiScoreResult';
import type { InternalApiNote } from './InternalApiNote';
import {
    InternalApiNoteFromJSON,
    InternalApiNoteFromJSONTyped,
    InternalApiNoteToJSON,
    InternalApiNoteToJSONTyped,
} from './InternalApiNote';
import type { InternalApiTransaction } from './InternalApiTransaction';
import {
    InternalApiTransactionFromJSON,
    InternalApiTransactionFromJSONTyped,
    InternalApiTransactionToJSON,
    InternalApiTransactionToJSONTyped,
} from './InternalApiTransaction';
import type { InternalApiMonitoringAlertPriority } from './InternalApiMonitoringAlertPriority';
import {
    InternalApiMonitoringAlertPriorityFromJSON,
    InternalApiMonitoringAlertPriorityFromJSONTyped,
    InternalApiMonitoringAlertPriorityToJSON,
    InternalApiMonitoringAlertPriorityToJSONTyped,
} from './InternalApiMonitoringAlertPriority';

/**
 * 
 * @export
 * @interface InternalApiMonitoringAlert
 */
export interface InternalApiMonitoringAlert {
    /**
     * 
     * @type {number}
     * @memberof InternalApiMonitoringAlert
     */
    id: number;
    /**
     * 
     * @type {InternalApiMonitoringAlertPriority}
     * @memberof InternalApiMonitoringAlert
     */
    priority?: InternalApiMonitoringAlertPriority;
    /**
     * 
     * @type {string}
     * @memberof InternalApiMonitoringAlert
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiMonitoringAlert
     */
    statusId: number;
    /**
     * 
     * @type {InternalApiPerson}
     * @memberof InternalApiMonitoringAlert
     */
    person: InternalApiPerson;
    /**
     * 
     * @type {Array<InternalApiScoreResult>}
     * @memberof InternalApiMonitoringAlert
     */
    score: Array<InternalApiScoreResult>;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiMonitoringAlert
     */
    assignee?: InternalApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiMonitoringAlert
     */
    createdTime: Date;
    /**
     * 
     * @type {InternalApiTransaction}
     * @memberof InternalApiMonitoringAlert
     */
    transaction?: InternalApiTransaction;
    /**
     * 
     * @type {Array<InternalApiNote>}
     * @memberof InternalApiMonitoringAlert
     */
    notes: Array<InternalApiNote>;
}



/**
 * Check if a given object implements the InternalApiMonitoringAlert interface.
 */
export function instanceOfInternalApiMonitoringAlert(value: object): value is InternalApiMonitoringAlert {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function InternalApiMonitoringAlertFromJSON(json: any): InternalApiMonitoringAlert {
    return InternalApiMonitoringAlertFromJSONTyped(json, false);
}

export function InternalApiMonitoringAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiMonitoringAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'priority': json['priority'] == null ? undefined : InternalApiMonitoringAlertPriorityFromJSON(json['priority']),
        'status': json['status'],
        'statusId': json['statusId'],
        'person': InternalApiPersonFromJSON(json['person']),
        'score': ((json['score'] as Array<any>).map(InternalApiScoreResultFromJSON)),
        'assignee': json['assignee'] == null ? undefined : InternalApiAssignmentUserFromJSON(json['assignee']),
        'createdTime': (new Date(json['createdTime'])),
        'transaction': json['transaction'] == null ? undefined : InternalApiTransactionFromJSON(json['transaction']),
        'notes': ((json['notes'] as Array<any>).map(InternalApiNoteFromJSON)),
    };
}

export function InternalApiMonitoringAlertToJSON(json: any): InternalApiMonitoringAlert {
    return InternalApiMonitoringAlertToJSONTyped(json, false);
}

export function InternalApiMonitoringAlertToJSONTyped(value?: InternalApiMonitoringAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'priority': InternalApiMonitoringAlertPriorityToJSON(value['priority']),
        'status': value['status'],
        'statusId': value['statusId'],
        'person': InternalApiPersonToJSON(value['person']),
        'score': ((value['score'] as Array<any>).map(InternalApiScoreResultToJSON)),
        'assignee': InternalApiAssignmentUserToJSON(value['assignee']),
        'createdTime': value['createdTime'].toISOString(),
        'transaction': InternalApiTransactionToJSON(value['transaction']),
        'notes': ((value['notes'] as Array<any>).map(InternalApiNoteToJSON)),
    };
}

